import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import NotificationListLayer from "../../components/Notification/NotificationListLayer";


const NotificationList = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Notification" />

        {/* BookingListLayer */}
        <NotificationListLayer />

      </MasterLayout>

    </>
  );
};

export default NotificationList; 
